module.exports = __webpack_public_path__ + "img/enableconfigicon.8647768b.svg";